export const stickyScroll = {
    data: function () {
        return {
            isIE: undefined,
            scrollPos: 0,
        };
    },
    methods: {
        addStickyListener() {
            const userAgent = navigator.userAgent;
            this.isIE = /(msie|trident)/i.test(userAgent);

            window.addEventListener("scroll", this.onStickyScroll);
        },
        onStickyScroll() {
            const top = document.body.getBoundingClientRect().top;
            this.stickyScroll(top - this.scrollPos, this.$refs.leftCol);

            if (this.$refs.rightCol) {
                this.stickyScroll(top - this.scrollPos, this.$refs.rightCol);
            }

            this.scrollPos = top;
        },
        stickyScroll(scrollOffset, el) {
            if (this.isIE) {
                // IE11 has terrible sticky support, so we're just going to exclude it completely
                el.style.top = 0;
            } else {
                const top = parseInt(el.style.top) || 0;
                const marginTop = 32;
                const height = el.offsetHeight + marginTop;
                const headerHeight = 0;

                if (height > 0) {
                    // ignore if not visible, we don't care then.
                    let minTop = window.innerHeight - height + marginTop;

                    if (minTop > headerHeight) {
                        minTop = headerHeight;
                    }
                    let offsetTop = top + scrollOffset;

                    if (offsetTop < minTop) {
                        offsetTop = minTop;
                    } else if (offsetTop > headerHeight) {
                        offsetTop = headerHeight;
                    }

                    el.style.top = `${offsetTop}px`;
                }
            }
        },
    },
    mounted: function () {
        this.addStickyListener();
    },
};
